export async function api(url, options = {}) {
  const res = await fetch(url, {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json().catch(() => ({ success: false, message: 'رد غير صالح' }));
  if (res.status === 401 && !url.includes('/auth/')) {
    location.href = '/login';
    throw new Error('unauthorized');
  }
  if (!res.ok) throw new Error(data.message || 'حدث خطأ');
  return data;
}